import React, { FC } from 'react';
import { Link as ChakraLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import NextLink from 'next/link';

interface LinkProps extends ChakraLinkProps {}

const Link: FC<LinkProps> = ({ children, href, ...props }) => (
  <ChakraLink asChild colorPalette='brand' variant='underline' {...props}>
    <NextLink href={href}>{children}</NextLink>
  </ChakraLink>
);

export default Link;
